export const getAvatarLink = (fullLink: string): string => {
  if (!fullLink) return ""
  // API отдаёт путь без ведущего слэша ("static/images/user_default.svg"),
  // но местами он приходит с ним — срезаем только если он есть.
  // Безусловный substring(1) съедал первый символ пути и ломал все аватарки.
  return `${process.env.VUE_APP_API_URL}${fullLink.replace(/^\//, "")}`
}
